/* ============================================================
   July Summer Ride Sale — interactions
   - Countdown to the sale end date (visitor's LOCAL 23:59:59)
   - Click-to-copy discount codes (with graceful fallback)
   - Toast notifications
   The end date is passed in from the section via a data-attribute,
   so nothing is hard-coded here.
   ============================================================ */
(function () {
  "use strict";

  function initRoot(root) {
    if (!root || root.dataset.jsaleInit === "1") return;
    root.dataset.jsaleInit = "1";

    /* ---------- Toast ---------- */
    var toast = root.querySelector(".toast");
    var toastTimer = null;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add("show");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("show");
      }, 1600);
    }

    /* ---------- Countdown ---------- */
    var cd = root.querySelector(".countdown");
    var cta = root.querySelector(".hero-cta");
    var endDate = root.getAttribute("data-end-date"); // "YYYY-MM-DD"
    var endedLabel = root.getAttribute("data-ended-label") || "Sale Ended";
    var end = null;

    if (endDate && /^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
      var parts = endDate.split("-");
      // 23:59:59 in the VISITOR'S local timezone
      end = new Date(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2], 10),
        23, 59, 59
      ).getTime();
    }

    function pad(n) { return n < 10 ? "0" + n : "" + n; }

    var els = cd
      ? {
          d: cd.querySelector("[data-cd='d']"),
          h: cd.querySelector("[data-cd='h']"),
          m: cd.querySelector("[data-cd='m']"),
          s: cd.querySelector("[data-cd='s']")
        }
      : null;

    var ended = false;
    var timer = null;

    function tick() {
      if (end === null || !els) return;
      var diff = end - Date.now();
      if (diff <= 0) {
        diff = 0;
        if (!ended) {
          ended = true;
          if (cta) cta.textContent = endedLabel;
          if (timer) { clearInterval(timer); timer = null; }
        }
      }
      if (els.d) els.d.textContent = pad(Math.floor(diff / 86400000));
      if (els.h) els.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (els.m) els.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (els.s) els.s.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    if (end !== null && els) {
      tick();
      timer = setInterval(tick, 1000);
    }

    /* ---------- Variant picker ----------
       Selecting a variant swaps the card image and rewrites the CTA so the
       shopper checks out with exactly what they picked. Sold-out variants are
       rendered disabled by Liquid, so they never reach this handler. */
    root.querySelectorAll(".bike-variants").forEach(function (group) {
      var card = group.closest(".bike-card");
      if (!card) return;

      var img = card.querySelector(".bike-img");
      var cta = card.querySelector(".bike-cta");
      var code = group.getAttribute("data-code") || "";
      var direct = group.getAttribute("data-direct") === "true";
      var productUrl = group.getAttribute("data-product-url") || "";
      var buttons = group.querySelectorAll(".bike-variant");

      function select(btn) {
        if (btn.disabled || btn.getAttribute("data-available") !== "true") return;

        buttons.forEach(function (b) {
          b.classList.remove("is-active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-pressed", "true");

        // Swap the image only when this variant actually has its own photo —
        // otherwise keep whatever is showing rather than blanking the card.
        var src = btn.getAttribute("data-img");
        if (img && src) {
          img.src = src;
          var ss = btn.getAttribute("data-srcset");
          if (ss) img.srcset = ss;
          var alt = btn.getAttribute("data-alt");
          if (alt) img.alt = alt;
        }

        if (!cta) return;
        var vid = btn.getAttribute("data-vid");
        if (direct && vid && code) {
          cta.href = "/cart/" + vid + ":1?discount=" + encodeURIComponent(code);
        } else if (vid && productUrl) {
          // Product-page mode: preselect the variant so the shopper lands on it
          var dest = productUrl + "?variant=" + vid;
          cta.href = code
            ? "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(dest)
            : dest;
        }
      }

      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () { select(btn); });
      });
    });

    /* ---------- Mobile product detail toggles (October 2026) ---------- */
    root.querySelectorAll("[data-bike-details-toggle]").forEach(function (button) {
      var card = button.closest(".bike-card");
      if (!card) return;

      button.addEventListener("click", function () {
        var open = !card.classList.contains("is-details-open");
        card.classList.toggle("is-details-open", open);
        button.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    /* ---------- Click-to-copy codes ---------- */
    root.querySelectorAll(".copy-code").forEach(function (el) {
      function copy() {
        var code = el.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () { showToast("Code " + code + " copied!"); },
            function () { showToast("Code: " + code); }
          );
        } else {
          showToast("Code: " + code);
        }
      }
      el.addEventListener("click", copy);
      // keyboard accessible (element carries role="button" tabindex="0")
      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          copy();
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(".july-sale").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Re-init inside the Shopify theme editor when the section is
     re-rendered (blocks added / settings changed). */
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector(".july-sale");
    if (root) { root.dataset.jsaleInit = ""; initRoot(root); }
  });
})();
